import React from 'react';
import { useAuthStore } from '../lib/store';

function Dashboard() {
  const user = useAuthStore(state => state.user);

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">
        Welcome to Your Dashboard
      </h1>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* Medications Summary Card */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Medications</h2>
          <p className="text-gray-600">Track and manage your medications</p>
          <a href="/medications" className="text-blue-600 hover:text-blue-800 mt-4 inline-block">
            View Medications →
          </a>
        </div>

        {/* Reminders Summary Card */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Reminders</h2>
          <p className="text-gray-600">Set up and manage your medication reminders</p>
          <a href="/reminders" className="text-blue-600 hover:text-blue-800 mt-4 inline-block">
            View Reminders →
          </a>
        </div>

        {/* Mood Tracker Summary Card */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Mood Tracker</h2>
          <p className="text-gray-600">Monitor your daily mood patterns</p>
          <a href="/mood" className="text-blue-600 hover:text-blue-800 mt-4 inline-block">
            View Mood Tracker →
          </a>
        </div>
      </div>
    </div>
  );
}

export default Dashboard;